export const getScrollElementForEvent = (
  scrollElement: HTMLElement | null,
): HTMLElement | Document | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return scrollElement === document.body ? document : scrollElement;
};
